import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { footerWrapper, stepsWrapper } from './SetupBundleModal.css';
import { SetupFirstBundleVM } from '../setupFirstBundle.vm';
import { Price } from '../../bundles/subscription/view/form/Price';

export type SetupBundleModalProps = SetupFirstBundleVM['setupBundleModal'];

export const SetupBundleModal: React.FC<SetupBundleModalProps> = ({
  isOpen,
  close,
  ...p
}) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    modalClassName="w-full md:w-[1120px] h-[100%] md:h-[800px]"
    contentClassName="h-[100%]"
    disableBackdropClick={true}
    footer={<Footer stepCta={p.stepCta} />}
  >
    <div className={stepsWrapper}>
      <Step {...p} />
    </div>
  </Modal>
);

const Step = ({
  step,
  ...p
}: Pick<
  SetupBundleModalProps,
  'step' | 'control' | 'transformPrice' | 'freeTrial' | 'error' | 'dispatch'
>) => {
  switch (step) {
    case 1:
      return <Price {...p} />;
  }
};

const Footer: React.FC<Pick<SetupBundleModalProps, 'stepCta'>> = ({
  stepCta,
}) => (
  <div className={footerWrapper}>
    {stepCta.map(({ title, onClick, variant, submitting }) => (
      <Button
        key={title}
        color="neutral"
        onClick={onClick}
        variant={variant || 'filled'}
        disabled={submitting}
        loading={submitting}
      >
        {title}
      </Button>
    ))}
  </div>
);
